export enum GameAdminInviteUIEnum {
  ValidateEmail = 1,
  InputUserData = 2,
  ViewVerificationCode = 3,
  ShowLoading = 4,
  AddExistingUser = 5
}
